import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useTranslate } from 'react-admin'

interface IWarningDialog {
    open: boolean
    title: string
    content?: string
    JSXContent?: any
    maxWidth?: false | 'sm' | 'xs' | 'md' | 'lg' | 'xl' | undefined
    handleContinue: () => void
    handleClose: () => void
}
const WarningDialog = ({
    open,
    title,
    content,
    JSXContent,
    maxWidth = 'sm',
    handleContinue,
    handleClose
}: IWarningDialog) => {
    const translate = useTranslate()

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={maxWidth}
            >
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                {content && (
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {content}
                        </DialogContentText>
                    </DialogContent>
                )}
                {JSXContent && <DialogContent children={JSXContent}></DialogContent>}

                <DialogActions>
                    <Button onClick={handleClose} variant="text" color="primary">
                        {translate('manager.resources.model_manager.warning_dialog.cancel')}
                    </Button>

                    <Button onClick={handleContinue} variant="contained" color="primary" autoFocus>
                        {translate('manager.resources.model_manager.warning_dialog.confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default WarningDialog
